import {
  ContentCompact,
  Section,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';
import { HeaderHome } from 'components/headers/HeaderNotification';
import { TelevetBenefitEmptyStateDisplay } from './TelevetBenefitEmptyStateDisplay';

export const TelevetBenefitEmptyState = () => {
  return (
    <ContentCompact>
      <HeaderHome />
      <Section>
        <TitleAndDescription
          title="Teleconsulta veterinária"
          description="Médicos veterinários qualificados para orientações imediatas 24h por dia, 7 dias por semana."
        />
        <TelevetBenefitEmptyStateDisplay />
      </Section>
    </ContentCompact>
  );
};
